
export default {
  data() {
    return {
      successMsgShown: false,

      optionsMain: [
        {
          name: "withBg",
          label: this.$t("label.withBg"),
          type: "checkbox",
        },
      ],
      options: [
        {
          name: "title",
          label: this.$t("label.title"),
          type: "text",
        },
      ],
      optionsChild: [
        {
          name: "icon",
          label: this.$t("label.icon"),
          type: "image",
          size: "16x16",
        },
        {
          name: "description",
          label: this.$t("label.description"),
          type: "tipTap",
        },
        {
          name: "text",
          label: this.$t("label.text"),
          type: "text",
        },
      ],
    };
  },

  methods: {
    showSuccessMsg() {
      this.successMsgShown = true;

      setTimeout(() => {
        const element = document.getElementById("success-msg");
        if (element) {
          element.scrollIntoView();
        } else this.$scrollToTop();
      }, 50);
    },
  },
};
